<template>
  <div class="row">
    <div class="col-12">
      <b-card
          header="Historic Workers"
          header-tag="h4"
          body-class="mb-3 record_card_body"
      >
        <div class="row">
          <div class="col-12 mb-3">
            <h5 class="b3_color">
              Workers with past assignments for this company who are no longer active.
            </h5>
          </div>

          <div class="col-12" style="min-height: 600px">
            <historicDatatable
                :row-data="rows"
                :columns="columns"
                :loading-message="'Loading historic workers...'"
                :no-rows-message="'No historic workers found'"
                :paginationPageSize="50"
                :type="'assignment'"
                :record-type="'assignment'"
            />
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import historicDatatable from 'datatables/assignments_datatable';

export default {
  name: 'c_historic_assigned_workers',

  components: {
    historicDatatable,
  },

  data() {
    return {
      loading: false,
      rows: [],

      columns: [
        {
          headerName: 'Worker',
          maxWidth: 180,
          valueGetter: params =>
              `${params.data.first_name} ${params.data.surname}`,
        },
        {
          headerName: 'Assignments',
          maxWidth: 120,
          field: 'assignment_count',
        },
        {
          headerName: 'First Assignment',
          maxWidth: 140,
          field: 'first_assignment_start',
          valueFormatter: params =>
              params.value
                  ? this.$options.filters.formatDate(params.value)
                  : '',
        },
        {
          headerName: 'Last Assignment',
          maxWidth: 140,
          field: 'last_assignment_end',
          valueFormatter: params =>
              params.value
                  ? this.$options.filters.formatDate(params.value)
                  : '',
        },
        {
          headerName: 'Last Order Ref',
          maxWidth: 140,
          field: 'last_order_ref',
        },
        {
          headerName: 'Sites',
          maxWidth: 220,
          valueGetter: params =>
              Array.isArray(params.data.site_names_worked)
                  ? params.data.site_names_worked.join(' | ')
                  : '',
          valueFormatter: params => {
            const sites = params.data.site_names_worked;
            if (!Array.isArray(sites) || sites.length === 0) return '';
            if (sites.length <= 2) return sites.join(', ');
            return `${sites[0]}, ${sites[1]} (+${sites.length - 2})`;
          },
        },
        {
          headerName: '# Sites',
          maxWidth: 100,
          field: 'site_count',
        },
      ],

    };
  },

  async mounted() {
    await this.loadHistoricWorkers();
  },

  methods: {
    async loadHistoricWorkers() {
      this.loading = true;

      try {
        const companyRes = await axios.get(
            `${this.crmApiPath}contact/${this.$store.state.auth.me.contact_id}/company/show`
        );

        const companyId = companyRes.data.id;

        const res = await axios.get(
            `${this.crmApiPath}assignments/company/sunset/historic_assignments/${companyId}`
        );

        this.rows = res.data ?? [];
      } catch (e) {
        console.error('Failed to load historic workers', e);
        this.rows = [];
      } finally {
        this.loading = false;
      }
    },

    siteNamesWorkedVg(params) {
      const sites = params.data.site_names_worked;

      if (!Array.isArray(sites) || sites.length === 0) {
        return '';
      }

      // simple, safe preview – you can improve UI later
      if (sites.length <= 2) {
        return sites.join(', ');
      }

      return `${sites[0]}, ${sites[1]} (+${sites.length - 2})`;
    },
  },
};
</script>

